import styled from "@emotion/styled";

type BadDataOverlayProps = {
  entity?: "job" | "stop";
};

const BadDataOverlay = ({entity = "job"}: BadDataOverlayProps) => {
  return (
    <Container data-testid={`${entity}-panel-bad-data-overlay`}>
      There is a {entity} with bad data that is causing the process that loads these {entity}s to fail.
    </Container>
  );
};

const Container = styled.div`
  background-color: white;
  inset: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: "Roboto", sans-serif;
  font-size: 14px;
`;

export default BadDataOverlay;
